//section Rendaring and Fecth call functionality
document.addEventListener("DOMContentLoaded", function () {
    window.fetchPdpData = function (productUrl) {
        const productHandel = productUrl;
        const desiredPath = productHandel.split("?")[0];
        const popupsectionId = "template--17488770793723__main";
        const apiUrl = `https://www.superkicks.in${desiredPath}?view=quick-buy`

        // Show shimmer effect
        const shimmerCardMain = document.querySelector('.shimmer-upsell-card-main.shimmer-popup');
        const cardUpsellWraper = document.querySelector('.card-upsell--data');
        shimmerCardMain.classList.remove('hidden');
        cardUpsellWraper.classList.add('hidden');

        fetch(apiUrl)
            .then(response => response.text())
            .then(data => {
                const parser = new DOMParser();
                const htmlDocument = parser.parseFromString(data, 'text/html');
                const targetSection = htmlDocument.querySelector('#qwick-buy__info');
                const buyPopover = document.querySelector('buy-popover');

                if (buyPopover && targetSection) {
                    const cardUpsellWraper = buyPopover.querySelector('.card-upsell--data');
                    cardUpsellWraper.innerHTML = targetSection.innerHTML;

                    // Hide shimmer and show fetched data
                    shimmerCardMain.classList.add('hidden');
                    cardUpsellWraper.classList.remove('hidden');
                    document.querySelector("body").classList.add("overflow-hidden");
                } else {
                    console.error('Error: buy-popover or targetSection not found.');
                }
            })
            .catch(error => console.error('Error:', error));
    };
   // close quick-buy-product popup when clicking outside of it
    window.addEventListener('click', function(event) {
        const buyPopover = document.querySelector('buy-popover');
        if ((!event.target.closest('.with-variants-button')) && ( !event.target.closest('#popover-container')) && ( !event.target.closest('.card-upsell-button')) ){
            document.querySelector("body").classList.remove("overflow-hidden");
            document.querySelector('.popup-overlay').classList.remove('popup-background-shadow')
            buyPopover.removeAttribute('open');
      }
    })

});

